import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { placeHolderShimmer } from '../../../styles/keyFrames';
var StyledRect = /*#__PURE__*/styled.div.withConfig({
  displayName: "Rect__StyledRect",
  componentId: "a8t9tg-0"
})(["width:", ";height:", ";margin-right:0.625rem;animation-name:", ";animation-duration:1.25s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-timing-function:linear;background:linear-gradient(to right,#eeeeee 10%,#dddddd 18%,#eeeeee 33%);background-size:100vw 104px;"], function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return theme.sizes[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return theme.sizes[size];
}, placeHolderShimmer);
var Rect = function Rect(_ref3) {
  var size = _ref3.size;
  return /*#__PURE__*/React.createElement(StyledRect, {
    size: size
  });
};
Rect.defaultProps = {
  size: 'sz16'
};
Rect.propTypes = {
  size: PropTypes.string
};
export default Rect;